<div class="notification-bell">
  <button type="button"
          class="bell-button"
          [attr.aria-expanded]="isOpen"
          aria-label="Open notifications"
          (click)="toggleDropdown()">
    <!-- Bell Icon SVG -->
    <svg class="bell-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </svg>

    <!-- Text Label -->
    <span class="bell-text">{{ 'notifications.title' | translate }}</span>

    <!-- Unread Badge -->
    <span class="bell-badge" *ngIf="(unreadCount$ | async) as count">
      {{ count > 99 ? '99+' : count }}
    </span>
  </button>
</div>

<!-- Dropdown Template (rendered via CDK Overlay in body) -->
<ng-template #dropdownTemplate>
  <div class="notification-dropdown"
       (click)="$event.stopPropagation()">
    <div class="dropdown-header">
      <h3 class="dropdown-title">{{ 'notifications.title' | translate }}</h3>
      <div class="dropdown-header__right">
        <span class="unread-count" *ngIf="(unreadCount$ | async) as count">
          {{ count }} {{ 'notifications.unread' | translate }}
        </span>
        <button *ngIf="canBroadcastNotifications"
                type="button"
                class="new-notification-button"
                [attr.title]="'notifications.newNotification' | translate"
                [attr.aria-label]="'notifications.newNotification' | translate"
                (click)="openNewNotification($event)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>
      </div>
    </div>

    <div class="notification-list">
      <div *ngIf="(notifications$ | async)?.length === 0" class="notification-empty">
        <svg class="empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
        <p>{{ 'notifications.empty' | translate }}</p>
      </div>

      <div *ngFor="let notification of notifications$ | async; trackBy: trackById"
           class="notification-item"
           [class.notification-item--unread]="!notification.Managed"
           [ngClass]="getNotificationTypeClass(notification.MessageType)"
           (click)="navigateToNotification(notification)">
        <div class="notification-content">
          <!-- Type Icon -->
          <div class="notification-icon" [ngSwitch]="notification.MessageType">
            <svg *ngSwitchCase="'success'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9 12l2 2 4-4"></path>
            </svg>
            <svg *ngSwitchCase="'error'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
            <svg *ngSwitchCase="'warning'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            <svg *ngSwitchDefault viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
          </div>

          <!-- Message Content -->
          <div class="notification-text">
            <p class="notification-message">{{ notification.Message }}</p>
            <span class="notification-time">{{ formatDate(notification.EventTimestamp) }}</span>
          </div>

          <!-- Mark as Read Button: spunta (azione), lo stato è reso dalla riga -->
          <button *ngIf="!notification.Managed"
                  type="button"
                  class="mark-read-button"
                  [attr.title]="'notifications.markAsRead' | translate"
                  [attr.aria-label]="'notifications.markAsRead' | translate"
                  (click)="markAsRead(notification, $event)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="dropdown-footer">
      <button type="button" class="see-all-button" (click)="viewAll()">
        {{ 'notifications.seeAll' | translate }}
      </button>
    </div>
  </div>
</ng-template>
